var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22039 15.0984C4.00179 14.3951 5.0616 14 6.16667 14H12.8333C13.9384 14 14.9982 14.3951 15.7796 15.0984C16.561 15.8016 17 16.7554 17 17.75V19.25C17 19.6642 16.6269 20 16.1667 20C15.7064 20 15.3333 19.6642 15.3333 19.25V17.75C15.3333 17.1533 15.0699 16.581 14.6011 16.159C14.1323 15.7371 13.4964 15.5 12.8333 15.5H6.16667C5.50363 15.5 4.86774 15.7371 4.3989 16.159C3.93006 16.581 3.66667 17.1533 3.66667 17.75V19.25C3.66667 19.6642 3.29357 20 2.83333 20C2.3731 20 2 19.6642 2 19.25V17.75C2 16.7554 2.43899 15.8016 3.22039 15.0984Z",
    fill: "#424F6D",
    stroke: "#424F6D",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.6C8.67452 5.6 7.6 6.67452 7.6 8C7.6 9.32548 8.67452 10.4 10 10.4C11.3255 10.4 12.4 9.32548 12.4 8C12.4 6.67452 11.3255 5.6 10 5.6ZM6 8C6 5.79086 7.79086 4 10 4C12.2091 4 14 5.79086 14 8C14 10.2091 12.2091 12 10 12C7.79086 12 6 10.2091 6 8Z",
    fill: "#424F6D",
    stroke: "#424F6D",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.032 14.572C18.1701 14.1643 18.7155 13.9191 19.2502 14.0244C20.3228 14.2355 21.2731 14.7123 21.9518 15.3798C22.6305 16.0473 22.9992 16.8678 23 17.7123V19.2376C23 19.6587 22.5523 20 22 20C21.4478 20 21.0001 19.6587 21.0001 19.2376V17.7135C20.9995 17.2068 20.7783 16.7144 20.3712 16.3139C19.9639 15.9134 19.3938 15.6274 18.7502 15.5007C18.2155 15.3954 17.8939 14.9796 18.032 14.572Z",
    fill: "#424F6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 17.7135V19.2376C21.0001 19.6587 21.4478 20 22 20C22.5523 20 23 19.6587 23 19.2376V17.7123C22.9992 16.8678 22.6305 16.0473 21.9518 15.3798C21.2731 14.7123 20.3228 14.2355 19.2502 14.0244C18.7155 13.9191 18.1701 14.1643 18.032 14.572C17.8939 14.9796 18.2155 15.3954 18.7502 15.5007C19.3938 15.6274 19.9639 15.9134 20.3712 16.3139C20.7783 16.7144 20.9995 17.2068 21.0001 17.7135Z",
    stroke: "#424F6D",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0314 4.61716C14.1682 4.17819 14.7121 3.91344 15.2463 4.02584C16.32 4.25178 17.2718 4.76498 17.9514 5.48455C18.6311 6.20411 19 7.0891 19 8C19 8.9109 18.6311 9.79589 17.9514 10.5155C17.2718 11.235 16.32 11.7482 15.2463 11.9742C14.7121 12.0866 14.1682 11.8218 14.0314 11.3828C13.8947 10.9439 14.2168 10.4969 14.751 10.3845C15.3953 10.2489 15.9663 9.94101 16.3741 9.50927C16.7819 9.07753 17.0032 8.54654 17.0032 8C17.0032 7.45346 16.7819 6.92247 16.3741 6.49073C15.9663 6.05899 15.3953 5.75107 14.751 5.6155C14.2168 5.50311 13.8947 5.05613 14.0314 4.61716Z",
    fill: "#424F6D",
    stroke: "#424F6D",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.efc99374fcee2ed072c556915a1910a7.svg";
export { ForwardRef as ReactComponent };